import React from 'react';
import { View } from 'react-native';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
const S = {
    dividerHorizontal: { height: 1 },
    dividerVertical: { width: 1, flex: 1 },
};
const variantColors = {
    light: {
        primary: { backgroundColor: colors['color-border-light-primary'] },
        secondary: { backgroundColor: colors['color-border-light-secondary'] },
    },
    dark: {
        primary: { backgroundColor: colors['color-ui2-neutral-600'] },
        secondary: { backgroundColor: colors['color-border-dark-secondary'] },
    },
};
export const DNADivider = (props) => {
    const { vertical, height, width, style, fill, variant = 'primary', colorMode = 'light' } = props;
    return (<View style={[
            vertical ? S.dividerVertical : S.dividerHorizontal,
            variantColors[colorMode][variant],
            height ? { minHeight: height } : {},
            width ? { minWidth: width } : {},
            fill ? { flex: 1 } : {},
            style,
        ]}/>);
};
export default DNADivider;
//# sourceMappingURL=DNADivider.js.map